import { DateshipHeader } from "../components/DateshipHeader"
import { SwipeCard } from "../components/SwipeCard"
import { SwipePotMatchStack } from "../components/SwipePotStack"
import { rootStore } from "../StApp"
import { motion, AnimatePresence } from "framer-motion";
import { Transitions } from "../transitions/pageTransitions";

export const SelectMatches = () => {
    return (
        <motion.div className='flex-column center-both absolute' style={{ width: '100%', height: '100%' }}
            initial="initial"
            animate="in"
            exit="out"
            variants={Transitions.pageVariants}
            transition={Transitions.pageTransition}
        >
            <DateshipHeader store={rootStore.dateshipStore} />
            <SwipePotMatchStack />
            <h4 style={{ position: 'absolute', bottom: 5, textAlign: 'center' }} >The above people have liked you. See if you find them same.</h4>
        </motion.div>
    )
}